export default "__VITE_ASSET__b1019d4d__"